// extracted by mini-css-extract-plugin
export var billingAddress = "_rc-f";
export var contactInfo = "_rc-c";
export var customerInfoContainer = "_rc-b";
export var customerInfoRow = "_rc-9";
export var customerInfoSection = "_rc-a";
export var fullWidthDividerMobile = "_rc-g";
export var imageContainer = "_rc-1";
export var paymentMethod = "_rc-d";
export var priceText = "_rc-6";
export var priceTextMobile = "_rc-7";
export var product = "_rc-0";
export var productImage = "_rc-2";
export var productInfo = "_rc-4";
export var productTitle = "_rc-8";
export var quantityBadge = "_rc-3";
export var quantityText = "_rc-5";
export var shippingAddress = "_rc-e";